import { apiSlice } from '@/shared/api/apiSlice'
import { ServerResponse } from '@/shared/types/common'

import { ProductPayments } from '../model/types/PaymentSchema'

export const productApi = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getProductPayments: builder.query<ServerResponse<ProductPayments>, number>({
			query: productId => ({
				url: `/products/${productId}/payments`
			})
		})
	})
})

export const { useGetProductPaymentsQuery } = productApi
